import { Controller } from "@hotwired/stimulus";

// Toggles visibility of post type-specific fields in the community composer.
export default class extends Controller {
  static targets = ["eventFields", "bundleFields", "tab"];

  toggleFields(event) {
    const type = event.target.value;
    if (this.hasEventFieldsTarget) this.eventFieldsTargets.forEach((el) => el.classList.toggle("hidden", type !== "event"));
    if (this.hasBundleFieldsTarget) this.bundleFieldsTargets.forEach((el) => el.classList.toggle("hidden", type !== "bundle"));
    this.updateTabs();
  }

  updateTabs() {
    if (!this.hasTabTarget) return;
    this.tabTargets.forEach((tab) => {
      const input = tab.querySelector('input[type="radio"]');
      const active = input?.checked ?? false;
      tab.classList.toggle("bg-white", active);
      tab.classList.toggle("dark:bg-gray-700", active);
      tab.classList.toggle("text-gray-900", active);
      tab.classList.toggle("dark:text-white", active);
      tab.classList.toggle("shadow-sm", active);
      tab.classList.toggle("text-gray-600", !active);
      tab.classList.toggle("dark:text-gray-400", !active);
      tab.classList.toggle("hover:text-gray-900", !active);
      tab.classList.toggle("dark:hover:text-white", !active);
    });
  }
}
